export class ScreenController {
    constructor(host) {
        this.isMobile = false;
        this.mobileWidth = '640px';
        this._isMobile = () => {
            var _a;
            this.isMobile = !window.matchMedia(`(min-width: ${this.mobileWidth})`)
                .matches;
            (_a = this._host) === null || _a === void 0 ? void 0 : _a.requestUpdate();
        };
        this._host = host;
        host.addController(this);
        this.isMobile = !window.matchMedia(`(min-width: ${this.mobileWidth})`)
            .matches;
    }
    hostConnected() {
        window.addEventListener('resize', this._isMobile);
    }
    hostDisconnected() {
        window.removeEventListener('resize', this._isMobile);
    }
}
//# sourceMappingURL=ResizeController.js.map